import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerCallsAnalyticsResponse } from '../interfaces/apis/customer-calls-analytics';
import { visitsStatisticsDashboardResponse } from '../interfaces/apis/visits-statistics-dashboard';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class VisitsService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private baseUrl = `${environment.apiBaseUrl}/visits/`;

  /**
   * Gets visits statistics for the dashboard
   * @param from - Start date of the activity
   * @param to - End date of the activity
   * @returns Observable of visits statistics
   */
  getVisitsStatistics(
    from: Date,
    to: Date,
  ): Observable<visitsStatisticsDashboardResponse> {
    return this.http.get<visitsStatisticsDashboardResponse>(
      `${this.baseUrl}analytics/statistics`,
      {
        params: {
          from: this.configService.formatDateTimeForApi(from),
          to: this.configService.formatDateTimeForApi(to, true),
        },
      },
    );
  }

  getCustomerCallsAnalytics(
    userId: string,
    customerId: string,
    from: Date,
    to: Date,
  ): Observable<CustomerCallsAnalyticsResponse> {
    return this.http.get<CustomerCallsAnalyticsResponse>(
      `${this.baseUrl}analytics/users/${userId}/customers/${customerId}/calls`,
      {
        params: {
          from: this.configService.formatDateTimeForApi(from),
          to: this.configService.formatDateTimeForApi(to, true),
        },
      },
    );
  }
}
